// Display palette following EUROCONTROL HMI principles: calm dark background, muted map, colour only with a
// meaning (responsibility, transfer, alert).
export const C = {
  bg: '#14191c',
  ground: '#1a2024',
  airfield: '#1d2427',
  apron: '#2a3236',
  taxiway: '#353e43',
  taxilane: '#30383c',
  runway: '#0f1213',
  runwayEdge: '#59626a',
  marking: '#cfd6db',
  centreline: '#8a7a3c',
  building: '#363c42',
  buildingEdge: '#4b535a',
  terminal: '#3d444b',
  stand: '#59626a',
  label: '#8b98a3',
  mapLine: '#3c4a54',
  mapText: '#6b7b87',
  fix: '#6b7b87',
  ctr: '#4d5f6c',
  centreLineExt: '#4a5862',
  // traffic
  mine: '#e9eef1',
  other: '#77838c',
  calling: '#6fd3e8',
  selected: '#f2cf63',
  alert: '#ff5f57',
  warn: '#f2a33a',
  dep: '#9cc7e6',
  arr: '#e8c37a',
  route: '#6fd3e8',
  stopbar: '#e04a3f',
  holdline: '#d6a23a',
};
